import { roadA1F } from "../../utils/ROADS/roadA1F";
import RoadMapGeneric2 from "../../components/Roadmaps/RoadMapGeneric2";

const RoadMapA1F= (props) => <RoadMapGeneric2 {...props} roadData={roadA1F} />;
export default RoadMapA1F;